var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 25,
    viewBox: "0 0 80 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8698 1.40498L19.8852 24.6258L13.1723 24.6338L7.48747 5.18406L7.02686 3.71863L7.06485 3.73942L7.12729 3.774L7.06599 3.74206L7.06529 3.73972C7.09509 3.75575 7.12445 3.77213 7.15414 3.78833C8.17688 4.33016 12.7174 6.91933 15.5248 11.1138C15.9522 13.247 16.3614 15.1848 16.9392 17.2749L23.1505 1.40497H29.8698L29.8698 1.40498Z",
    fill: "#006CB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8797 17.0453C56.8328 21.879 52.5086 25 45.8425 25C43.0014 24.9694 40.2611 24.4106 38.7733 23.7582L39.6642 18.5501L40.4838 18.9251C42.5709 19.7936 43.9168 20.142 46.4565 20.142C48.2812 20.142 50.232 19.4267 50.2457 17.8647C50.2538 16.8454 49.4265 16.1219 46.958 14.9824C44.5546 13.8672 41.3683 12.0042 41.4088 8.66079C41.4393 4.13738 45.8592 0.984009 52.1256 0.984009C54.5797 0.984009 56.5449 1.4856 57.8047 1.96235L56.945 7.00349L56.3698 6.73251C55.2077 6.26383 53.7032 5.80914 51.6241 5.84145C49.1473 5.84145 47.9932 6.87754 47.9932 7.84774C47.9852 8.93003 49.3391 9.6558 51.5528 10.73C55.2158 12.3873 56.9118 14.4017 56.8794 17.0453H56.8797Z",
    fill: "#006CB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0731 1.40498H69.1764C67.6561 1.40498 66.5164 1.81877 65.8559 3.33957L56.4361 24.6564H63.0918C63.0918 24.6564 64.1819 21.7903 64.431 21.1603C65.1545 21.1603 71.6288 21.1766 72.5521 21.1766C72.7359 21.9902 73.3168 24.6564 73.3168 24.6564H79.2022L74.0731 1.40497V1.40498ZM66.253 16.4065C67.3926 13.5119 68.5353 10.5968 69.6207 7.67979C70.2451 10.5904 70.8832 13.4979 71.5166 16.4065H66.253Z",
    fill: "#006CB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4336 1.38251H38.7733L34.8067 24.6503H28.4686L32.4336 1.38251Z",
    fill: "#006CB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.382209 1.17567L11.1091 1.18319C12.4318 1.22997 13.498 1.65173 13.873 3.06862L15.5246 11.1139C12.7172 6.9194 8.1767 4.33026 7.15394 3.78843C7.12424 3.77223 7.09488 3.75585 7.06508 3.73982L7.06578 3.74216L7.12709 3.7741L7.06465 3.73952C6.89367 3.64574 6.72081 3.55344 6.54632 3.46294C4.6727 2.49066 2.60052 1.71103 0.382202 1.17566L0.382209 1.17567Z",
    fill: "#FAA841"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.fc45f2c175cb0fa546a811de2ab861ce.svg";
export { ForwardRef as ReactComponent };